import { type ReactNode } from 'react'
import { Column } from 'src/shared/components/Semantic/all'
import { Button } from 'src/shared/components/ui/button'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { useRequestContext } from '../hooks/RequestContext'

export const RequestTabShell = ({
  loadingMessage,
  requireQuoteItems = false,
  className,
  children,
}: {
  loadingMessage: string
  requireQuoteItems?: boolean
  className?: string
  children: ReactNode
}) => {
  const { t } = useLocalization()
  const {
    quote,
    isQuotePending,
    isQuoteItemsPending,
    isError,
    refetchQuote,
  } = useRequestContext()

  const isPending =
    isQuotePending || (requireQuoteItems && !!quote && isQuoteItemsPending)

  if (isPending) {
    return (
      <Column
        className={className ?? 'flex-1 items-center justify-center p-8'}
      >
        <p className="text-sm text-gray-500">{loadingMessage}</p>
      </Column>
    )
  }

  if (isError || !quote) {
    return (
      <Column
        className={
          className ??
          'flex-1 items-center justify-center gap-2 p-8 text-center'
        }
      >
        <h2>{t('Quote not found', 'Offert hittades inte')}</h2>
        <p className="text-sm text-gray-600">
          {t(
            'No quote matches this request.',
            'Ingen offert matchar denna förfrågan.'
          )}
        </p>
      </Column>
    )
  }

  return <>{children}</>
}
